module.exports = __webpack_public_path__ + "img/3bf31cb2a15f0346c4e53d04eb2d32e1.png";